export default __webpack_public_path__ + "static/media/schedule-maintenance-active.d23c09f2.svg";